import { getENV } from '@libs/common-next';
import { caPostalCode, usPostalCode } from '@libs/core';

const locale = getENV('NEXT_PUBLIC_LOCALE');

export const validateZipPostalCode = (code: string): boolean => {
    const trimmed = code.trim();
    if (!trimmed) return false;

    return locale === 'en-US' ? usPostalCode(trimmed) : caPostalCode(trimmed);
};
